import { useUiTranslator } from "../../../../../hooks/useUiTranslator";
import { useGetApiEasyAdministrationArea } from "../../../../../openapi/backendApi";
import { useEasySession } from "../../../../../providers/easySessionProvider";

import { JSX, useCallback, useEffect, useState } from "react";

import { PrintButtonArea } from "@4pace-print-button-area/core";
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Button, Skeleton } from "@mui/material";
import {
  useCsAttributes,
  useSessionId,
} from "@plansoft-configuration-renderer/framework";
import { useQueryClient } from "@tanstack/react-query";

let copyButtonAnimationTimeout: ReturnType<typeof setTimeout>;

export const PrintPreview = (): JSX.Element => {
  const sessionId = useSessionId();
  const queryClient = useQueryClient();
  const atts = useCsAttributes();
  const t = useUiTranslator();

  const { data: admindata } = useGetApiEasyAdministrationArea();
  const adminArea = admindata?.data.string;
  const [fileUrl, setFileUrl] = useState<string>();
  //const [fileHtmlBlobUrl, setFileHtmlBlobUrl] = useState<string>("");
  const [fileHtmlContent, setFileHtmlContent] = useState<string>("");
  const [copyBtnClicked, setCopyButtonClicked] = useState<boolean>(false);
  const { isLoggedIntoEasy } = useEasySession();
  const typeDesignationObj = atts.find(
    (att) => att.id === "A_TYPE_DESIGNATION",
  );

  let documentName = "";
  if (typeDesignationObj && typeDesignationObj.values) {
    documentName = typeDesignationObj.values[0].value;
  }
  if (documentName) {
    documentName = documentName.replace(/[\\./]/g, "_");
  } else {
    documentName = "WEG-DataSheet";
  }

  let areaIdentifier = "";
  if (adminArea === "WCES") {
    areaIdentifier = "printDataSheetWCES";
  } else if (adminArea === "WGS") {
    areaIdentifier = "printDataSheetWGS";
  } else {
    console.error("Invalid administration area in UtilsProductView", adminArea);
    areaIdentifier = "printDataSheetWGS";
  }

  const handlePrintBlob = (blob: Blob): void => {
    const newFile = new File([blob], documentName, { type: blob.type });
    setFileUrl(URL.createObjectURL(newFile));
  };

  const manipulateFileContent = (fileContent: string): string => {
    const regexImageHead =
      /<br\/><span><img\b[^>]*src=['"]data:image\/(png|jpg|jpeg);base64,[^'"]+['"][^>]*\/?><br\/><\/span>/gi;
    const regexFooter = /<footer>.*<\/footer>/;
    const regexFont = /(')?Aptos(')?/g;
    const newFontString = "Aptos, Roboto, sans-serif";
    /*const regexFiller1 = new RegExp(
      "<br/><span><br/></span><br/><span><br/></span>",
      "gi",
    ); */
    return fileContent
      .replace(regexImageHead, "")
      .replace(regexFooter, "")
      .replace(regexFont, newFontString);
    /*  .replace(regexImage, "")
      .replace(regexFiller1, ""); */
  };

  const fetchPrintPreviewHtml = useCallback(async (): Promise<void> => {
    let response;
    try {
      response = await fetch(
        `/preview/api/3pq-ot/getDataSheetHtml?id=${sessionId}&adminArea=WGS`,
        {
          method: "GET",
        },
      );
      const data = await response.json();
      if (data?.html && typeof data.html === "string") {
        const formattedHtmlString = manipulateFileContent(data.html);
        console.log("formattedHtmlString", formattedHtmlString);

        //const blob = new Blob([formattedHtmlString], { type: "text/html" });

        //const blobUrl = URL.createObjectURL(blob);
        //setFileHtmlBlobUrl(blobUrl);
        //const blobText = await blob.text();
        setFileHtmlContent(formattedHtmlString);
      }
    } catch (error) {
      console.error("Error in handleCopyPreviewData", error);
    }
  }, [sessionId]);

  useEffect(() => {
    if (!fileUrl) {
      const button = document.querySelector(
        "#document-print-button-wrapper>div>button",
      ) as HTMLButtonElement | null;

      if (button) {
        button.click();
      }
    }
    //eslint-disable-next-line
    fetchPrintPreviewHtml();
  }, [fileUrl, fetchPrintPreviewHtml]);

  const handleCopyPreviewData = async (): Promise<void> => {
    if (!fileHtmlContent) {
      return;
    }

    const clipboardData = [new ClipboardItem({ "text/html": fileHtmlContent })];

    await navigator.clipboard.write(clipboardData);
    setCopyButtonClicked(true);
    if (copyButtonAnimationTimeout) {
      clearTimeout(copyButtonAnimationTimeout);
    }
    copyButtonAnimationTimeout = setTimeout(() => {
      setCopyButtonClicked(false);
    }, 2000);
  };

  return (
    <>
      <Box>
        <Box display="flex" justifyContent="space-between" gap={2}>
          <Box>
            <Button
              variant="outlined"
              disabled={!fileHtmlContent}
              color={copyBtnClicked ? "success" : "primary"}
              sx={{
                mb: 1,
                textTransform: "uppercase",
                display: isLoggedIntoEasy ? "flex" : "none",
              }}
              onClick={() => {
                handleCopyPreviewData();
              }}
              startIcon={copyBtnClicked ? <CheckIcon /> : <ContentCopyIcon />}
            >
              {t("CustomApp:tooltip.copyToClipboard", "copy")}
            </Button>
          </Box>
          <Box id="document-print-button-wrapper">
            <PrintButtonArea
              queryClient={queryClient}
              areaIdentifier={areaIdentifier}
              locale="en-US"
              printRequestParams={{
                quoteId: sessionId,
              }}
              options={{
                orchestratorBasePath: "/preview",
                areaSx: { display: "flex", gap: 1 },
                buttonProps: {
                  variant: "outlined",

                  sx: {
                    default: {
                      textTransform: "uppercase",
                      visibility: "hidden",
                    },
                  },
                  startIcon: <DownloadIcon />,
                },
              }}
              fileName={documentName}
              handleBlob={handlePrintBlob}
            />
          </Box>
        </Box>
        {/*<Box
          height="29.7cm"
          maxHeight="100vh"
          maxWidth="100%"
          sx={{ boxShadow: "0 .5em 1em .25em rgba(0,0,0,.25)" }}
        >
          {fileHtmlBlobUrl ? (
            <embed src={fileHtmlBlobUrl} width="100%" height="100%" />
          ) : (
            <Skeleton variant="rectangular" width="100%" height="100%" />
          )}
        </Box>*/}
        <Box height="29.7cm" maxHeight="100vh" maxWidth="100%" mt={4}>
          {fileUrl ? (
            <embed src={fileUrl} width="100%" height="100%" />
          ) : (
            <Skeleton variant="rectangular" width="100%" height="100%" />
          )}
        </Box>
      </Box>
    </>
  );
};
